import React from "react";
import {
  Box,
  Typography,
  Switch,
  FormControlLabel,
  Stack,
} from "@mui/material";
import FontControls from "./FontControls";
import PositionControls from "./PositionControls";

const StyleAttributeForm = React.memo(function StyleAttributeForm({
  attributeId,
  label,
  values,
  onChange,
  onOpenColorPicker,
  fonts,
  positions,
  showPosition = true,
}) {
  const handleChange = (field, value) => {
    onChange(attributeId, { ...values, [field]: value });
  };

  return (
    <Box >
      <Box display="flex" alignItems="center" justifyContent="space-between" mb={2}>
        <Typography variant="subtitle1" fontWeight="bold">
          {label}
        </Typography>
        <FormControlLabel
          control={
            <Switch
              checked={values.show !== false}
              onChange={(e) => handleChange("show", e.target.checked)}
              sx={{
                "& .MuiSwitch-switchBase.Mui-checked": {
                  color: "#1976d2",
                },
                "& .MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track": {
                  bgcolor: "#1976d2",
                },
              }}
            />
          }
          label={values.show !== false ? "Visible" : "Oculto"}
        />
      </Box>

      {values.show !== false && (
        <Stack spacing={2} sx={{ pl: 2, borderLeft: "2px solid #f0f0f0" }}>        
          <FontControls
            font={values.font}
            fontSize={values.fontSize}
            fontWeight={values.fontWeight}
            color={values.color}
            onFontChange={(val) => handleChange("font", val)}
            onFontSizeChange={(val) => handleChange("fontSize", val)}
            onFontWeightChange={(val) => handleChange("fontWeight", val)}
            onOpenColorPicker={() => onOpenColorPicker(attributeId, values.color)}
            fonts={fonts}
          />
          
          {showPosition && (
            <PositionControls
              value={values.position}
              onChange={(val) => handleChange("position", val)}
              label="Alineación"
              positions={positions}
            />
          )}
        </Stack>
      )}
    </Box>
  );
});

export default StyleAttributeForm;
